interface PlusProps {
  x: number;
  y: number;
  scale: number;
  color: string;
}

export const Plus = ({ x, y, scale, color }: PlusProps) => {
  return (
    <path
      transform={`translate(${x}, ${y}) scale(${scale})`}
      d="M5.85882 3.30657C5.95294 3.30657 6 3.35363 6 3.44775V4.33716C6 4.43127 5.95294 4.47833 5.85882 4.47833H3.64235C3.60471 4.47833 3.58588 4.49716 3.58588 4.5348V6.70892C3.58588 6.80304 3.53882 6.8501 3.44471 6.8501H2.55529C2.46118 6.8501 2.41412 6.80304 2.41412 6.70892V4.5348C2.41412 4.49716 2.39529 4.47833 2.35765 4.47833H0.141177C0.0470588 4.47833 0 4.43127 0 4.33716V3.44775C0 3.35363 0.0470588 3.30657 0.141177 3.30657H2.35765C2.39529 3.30657 2.41412 3.28775 2.41412 3.2501V0.991275C2.41412 0.897157 2.46118 0.850098 2.55529 0.850098H3.44471C3.53882 0.850098 3.58588 0.897157 3.58588 0.991275V3.2501C3.58588 3.28775 3.60471 3.30657 3.64235 3.30657H5.85882Z"
      fill={color}
    />
  );
};
